var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "b-form",
            {
              ref: "form",
              staticClass: "repeater-form",
              style: { height: _vm.trHeight },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.addItem($event)
                },
                change: function ($event) {
                  return _vm.formChanged()
                },
              },
            },
            _vm._l(_vm.Items, function (item, index) {
              return _c(
                "b-row",
                {
                  key: item.id,
                  ref: "row",
                  refInFor: true,
                  attrs: { id: item.id },
                },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Operation Step",
                            "label-for": "Operation-stepoperationName",
                          },
                        },
                        [
                          _c("b-form-select", {
                            attrs: {
                              id: "operationName",
                              options: _vm.Product.operationStep,
                              "value-field": "name",
                              "text-field": "name",
                            },
                            model: {
                              value: item.operationName,
                              callback: function ($$v) {
                                _vm.$set(item, "operationName", $$v)
                              },
                              expression: "item.operationName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: { label: "Quality Name", "label-for": "name" },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "name",
                              type: "text",
                              placeholder: "Quality name",
                            },
                            model: {
                              value: item.name,
                              callback: function ($$v) {
                                _vm.$set(item, "name", $$v)
                              },
                              expression: "item.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: "Minimum Value",
                            "label-for": "minVal",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "minVal",
                              type: "text",
                              placeholder: "Accepted Value",
                            },
                            model: {
                              value: item.minValue,
                              callback: function ($$v) {
                                _vm.$set(item, "minValue", $$v)
                              },
                              expression: "item.minValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { attrs: { md: "2" } },
                    [
                      _c(
                        "b-form-group",
                        {
                          attrs: {
                            label: " Maximum Value",
                            "label-for": "maxVal",
                          },
                        },
                        [
                          _c("b-form-input", {
                            attrs: {
                              id: "maxVal",
                              type: "text",
                              placeholder: "Accepted Value",
                            },
                            model: {
                              value: item.maxValue,
                              callback: function ($$v) {
                                _vm.$set(item, "maxValue", $$v)
                              },
                              expression: "item.maxValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-col",
                    { staticClass: "mb-50", attrs: { lg: "2", md: "3" } },
                    [
                      _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "ripple",
                              rawName: "v-ripple.400",
                              value: "rgba(234, 84, 85, 0.15)",
                              expression: "'rgba(234, 84, 85, 0.15)'",
                              modifiers: { 400: true },
                            },
                          ],
                          staticClass: "mt-0 mt-md-2",
                          attrs: { variant: "outline-danger" },
                          on: {
                            click: function ($event) {
                              return _vm.removeItem(index)
                            },
                          },
                        },
                        [
                          _c("feather-icon", {
                            staticClass: "mr-25",
                            attrs: { icon: "XIcon" },
                          }),
                          _c("span", [_vm._v("Delete")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("b-col", { attrs: { cols: "12" } }, [_c("hr")]),
                ],
                1
              )
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "b-button",
        {
          directives: [
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { 400: true },
            },
          ],
          staticClass: "mb-2",
          attrs: { variant: "primary" },
          on: { click: _vm.addItem },
        },
        [
          _c("feather-icon", {
            staticClass: "mr-25",
            attrs: { icon: "PlusIcon" },
          }),
          _c("span", [_vm._v("Add Quality")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }